/// <amd-module name="Test/Analytics/TestAnalyticInsightsReportView/Stores/TestInsightsReportViewStore" />
import { AnalyticsExceptionType, extractODataError, recognizeAnalyticsException } from "Analytics/Common/Utilities/AnalyticsExceptionUtilities";
import * as CommonTypes from "Test/Analytics/Common/Types";
import { TestInsightsReportViewActions } from "Test/Analytics/TestAnalyticInsightsReportView/Actions/TestInsightsReportViewActions";
import { TestInsightsTrendChartActions } from "Test/Analytics/TestAnalyticsTrendChart/Actions/TestInsightsTrendChartActions";
import { TestInsightsTestHistoryListActions } from "Test/Analytics/TestInsightsHistoryList/Actions/TestInsightsTestHistoryListActions";
import { ITestHistoryListData } from "Test/Analytics/TestInsightsHistoryList/Types";
import { ITestResultTreeData } from "Test/common-util/Contracts/ViewContracts";
import { Store } from "VSS/Reflux/Store";

export interface ITestInsightsReportViewState {
    selectedTestResultTreeData: ITestResultTreeData;
    showDetailsPane: boolean;
    viewType: CommonTypes.ViewType;
    errorText?: string;
    detailsPanelErrorMessage?: string;
    detailsPanelErrorStatus?: number;
}

export class TestInsightsReportViewStore extends Store {
    private _state: ITestInsightsReportViewState;
    constructor(
        private _testInsightsTrendChartActions: TestInsightsTrendChartActions,
        private _testInsightsTestHistoryListActions: TestInsightsTestHistoryListActions,
        private _testInsightsReportViewActions: TestInsightsReportViewActions
    ) {
        super("");
        this._initialize();
    }

    public getState(): ITestInsightsReportViewState {
        return this._state;
    }

    public dispose(): void {
        this._testInsightsTrendChartActions.onError.removeListener(this._onError);
        this._testInsightsTestHistoryListActions.onError.removeListener(this._onError);
        this._testInsightsTestHistoryListActions.updateTestHistoryListAction.removeListener(this._onUpdateTestHistoryList);
        this._testInsightsReportViewActions.setTestResultTreeData.removeListener(this._setTestResultTreeData);
        this._testInsightsReportViewActions.closeDetailsPanel.removeListener(this._onCloseDetailsPanel);
    }

    private _initialize(): void {
        this._state = { showDetailsPane: false, viewType: CommonTypes.ViewType.TestInsightsReportView } as ITestInsightsReportViewState;
        this._testInsightsTrendChartActions.onError.addListener(this._onError);
        this._testInsightsTestHistoryListActions.onError.addListener(this._onError);
        this._testInsightsTestHistoryListActions.updateTestHistoryListAction.addListener(this._onUpdateTestHistoryList);
        this._testInsightsReportViewActions.setTestResultTreeData.addListener(this._setTestResultTreeData);
        this._testInsightsReportViewActions.closeDetailsPanel.addListener(this._onCloseDetailsPanel);
    }

    private _setTestResultTreeData = (item: ITestResultTreeData) => {
        this._state.selectedTestResultTreeData = item;
        this._state.showDetailsPane = true;
        this._state.detailsPanelErrorMessage = "";
        this._state.detailsPanelErrorStatus = undefined;

        this.emitChanged();
    };

    private _onCloseDetailsPanel = () => {
        this._state.showDetailsPane = false;

        this.emitChanged();
    };

    private _onUpdateTestHistoryList = (testHistoryListData: ITestHistoryListData) => {
        if (testHistoryListData) {
            if (testHistoryListData.testHistoryListItems.length === 0) {
                this._state.viewType = CommonTypes.ViewType.NoTestDataView;
            } else if (this._state.viewType != CommonTypes.ViewType.ReportView) {
                this._state.viewType = CommonTypes.ViewType.TestInsightsReportView;
            }
        }

        this.emitChanged();
    };

    private _onError = (error: Error) => {
        if (recognizeAnalyticsException(error) === AnalyticsExceptionType.DataNotReady) {
            this._state.viewType = CommonTypes.ViewType.DataNotReadyView;
        } else {
            this._state.viewType = CommonTypes.ViewType.ErrorView;
            this._state.errorText = extractODataError(error);
        }
        this.emitChanged();
    };
}
